import {Pipe, PipeTransform} from '@angular/core';
import {MitarbeiterBase} from '../dtos/mitarbeiterBase';
import {DataMappingService} from '../services/data-mapping.service';

@Pipe({
  name: 'idToLnReturnLnAndFncname',
  standalone: false
})
export class IdToLnReturnLnAndFncnamePipe implements PipeTransform {
  constructor(private readonly mapping: DataMappingService) {}

  transform(
    value: number | unknown,
    mitarbeiters?: MitarbeiterBase[]
  ): Promise<string> {
    if (value) {
      if (typeof value !== 'number') {
        throw Error(
          `The pipe input value has to be a number but was '${typeof value}'`
        );
      }
      if (mitarbeiters) {
        return this.mapping.mapMitarbeiterIdToLaufnummerReturnLnAndFnc(
          value,
          mitarbeiters
        );
      }
      // Fallback to async to load mitarbeiters in service
      return this.mapping.mapMitarbeiterIdToLaufnummerReturnLnAndFncAsync(
        value
      );
    }
    return null;
  }
}
